import { render, staticRenderFns } from "./OrderAccessDialog.vue?vue&type=template&id=0f070054"
import script from "./OrderAccessDialog.vue?vue&type=script&lang=js"
export * from "./OrderAccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports